var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-pic"},[(_vm.hasProfileURL)?_c('smd-profile-img',{attrs:{"size":'s',"image":_vm.profilePic}}):_vm._e(),(!_vm.hasProfileURL)?_c('smd-profile-img-placeholder',{attrs:{"text":_vm.name}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }